// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://enljlnmefdpeswxykzyy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVubGpsbm1lZmRwZXN3eHlrenl5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc5MDcwNzksImV4cCI6MjA1MzQ4MzA3OX0.VYT_zBpZ9qjodbaaoNHtj6TU0LIIsNwJAFuyt4VhfEU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);